import { Circle, Hexagon01 } from "@untitledui/icons";
import { Dropdown } from "@/components/base/dropdown/dropdown";
import { cx } from "@/utils/cx";
import { FENCE_COLORS, FENCE_TYPE_ICONS } from "../constants";
import type { FenceCardProps } from "../types/fence";

export const FenceCard = ({
	fence,
	isSelected,
	onSelect,
	onEdit,
	onDelete,
}: FenceCardProps) => (
	<div
		className={cx(
			"flex items-center justify-between rounded-lg border p-3 transition-colors",
			isSelected
				? "border-blue-500 bg-blue-50"
				: "border-gray-200 hover:border-gray-300 hover:bg-gray-50"
		)}
	>
		<button
			className={cx(
				"flex min-w-0 flex-1 cursor-pointer items-center gap-3 rounded-md text-left",
				"focus-visible:outline focus-visible:outline-blue-500 focus-visible:outline-offset-2"
			)}
			onClick={() => onSelect?.(fence)}
			type="button"
		>
			<div className="flex h-8 w-8 shrink-0 items-center justify-center">
				{FENCE_TYPE_ICONS[fence.type] === "circle" ? (
					<Circle color={FENCE_COLORS.MARKER_STROKE} size={20} />
				) : (
					<Hexagon01 color={FENCE_COLORS.MARKER_STROKE} size={20} />
				)}
			</div>
			<span className="truncate font-medium text-gray-900">{fence.name}</span>
		</button>

		<Dropdown.Root>
			<Dropdown.HorizontalDotsButton
				className={cx("flex h-6 w-6 shrink-0 items-center justify-center")}
				onClick={(e: React.MouseEvent) => e.stopPropagation()}
			/>
			<Dropdown.Popover>
				<Dropdown.Menu>
					<Dropdown.Item label="Editar" onAction={() => onEdit(fence)} />
					<Dropdown.Separator />
					<Dropdown.Item label="Excluir" onAction={() => onDelete(fence)} />
				</Dropdown.Menu>
			</Dropdown.Popover>
		</Dropdown.Root>
	</div>
);
